import './init'
import Form from './form'

const ExtensionService = require('live/services/extension')

const _plugin = {
    name: 'Pipes to State',
    type: 'plugin-pipes2state',
    origin: 'Pipes to State',
    icon: '/content/plugin-pipes2state/logo48x48.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(_plugin)
